/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStepDocumentUploadAliases {
  FIELD_UPLOADER_DOCUMENTS = 'field-uploader-documents',
  FILE_UPLOADER_DOCUMENTS = 'file-uploader-documents',
  FORM_UPLOADER_DOCUMENTS = 'form-uploader-documents',
  LAYOUT_UPLOAD_DOCUMENTS = 'layout-upload-documents',
  PANEL_UPLOAD_DOCUMENTS = 'panel-upload-documents',
  TOAST_NOTIFICATION_UPLOAD_DOCUMENT = 'toast-notification-upload-document',
}
export { PseudonymAppointmentsStepDocumentUploadAliases };
